import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-73a28f58")

_pushScopeId("data-v-73a28f58")
const _hoisted_1 = { class: "document-form" }
const _hoisted_2 = /*#__PURE__*/_createVNode("p", { class: "title" }, "MDB-e申請 ドキュメント", -1)
const _hoisted_3 = {
  key: 0,
  class: "el-icon-document"
}
const _hoisted_4 = {
  key: 1,
  class: "el-icon-link"
}
const _hoisted_5 = /*#__PURE__*/_createVNode("p", null, "※フォームにアクセスできない方は下記様式をご使用ください", -1)
const _hoisted_6 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 1024 1024"
}
const _hoisted_7 = /*#__PURE__*/_createVNode("path", {
  fill: "currentColor",
  d: "M704 192h160v736H160V192h160v64h384zM288 512h448v-64H288zm0 256h448v-64H288zm96-576V96h256v96z"
}, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_link = _resolveComponent("el-link")
  const _component_el_card = _resolveComponent("el-card")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.docs, (fileName, index) => {
      return (_openBlock(), _createBlock(_component_el_card, {
        "body-style": { padding: 'px' },
        class: "doc",
        key: index
      }, {
        default: _withId(() => [
          (_ctx.getFileExtension(fileName) === 'pdf')
            ? (_openBlock(), _createBlock("i", _hoisted_3))
            : _createCommentVNode("", true),
          (_ctx.getFileExtension(fileName) !== 'pdf')
            ? (_openBlock(), _createBlock("i", _hoisted_4))
            : _createCommentVNode("", true),
          _createVNode("div", null, [
            (_ctx.getFileExtension(fileName) === 'pdf')
              ? (_openBlock(), _createBlock(_component_el_link, {
                  key: 0,
                  href: _ctx.basePath + _ctx.DOCS_MAP.get(fileName),
                  target: "_blank"
                }, {
                  default: _withId(() => [
                    _createTextVNode(_toDisplayString(fileName), 1)
                  ]),
                  _: 2
                }, 1032, ["href"]))
              : _createCommentVNode("", true),
            (_ctx.getFileExtension(fileName) !== 'pdf')
              ? (_openBlock(), _createBlock(_component_el_link, {
                  key: 1,
                  href: _ctx.DOCS_MAP.get(fileName),
                  target: "_blank"
                }, {
                  default: _withId(() => [
                    _createTextVNode(_toDisplayString(fileName), 1)
                  ]),
                  _: 2
                }, 1032, ["href"]))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 2
      }, 1024))
    }), 128)),
    _hoisted_5,
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.excels, (fileName, index) => {
      return (_openBlock(), _createBlock(_component_el_card, {
        "body-style": { padding: 'px' },
        class: "doc",
        key: index
      }, {
        default: _withId(() => [
          (_ctx.getFileExtension(fileName) === 'xlsx')
            ? (_openBlock(), _createBlock("svg", _hoisted_6, [
                _hoisted_7
              ]))
            : _createCommentVNode("", true),
          _createVNode("div", null, [
            _createVNode(_component_el_link, {
              href: _ctx.basePath + _ctx.DOCS_MAP.get(fileName),
              target: "_blank"
            }, {
              default: _withId(() => [
                _createTextVNode(_toDisplayString(fileName), 1)
              ]),
              _: 2
            }, 1032, ["href"])
          ])
        ]),
        _: 2
      }, 1024))
    }), 128))
  ]))
})